import { defineEnum } from '@siclop/kstone-vue'

export enum CrudType {
  Creation = 0,
  Modification = 1,
  Deletion = 2
}

export const useCrudTypeLabels = defineEnum({
  i18nPrefix: 'ksproject.enums.crudType',
  entries: {
    [CrudType.Creation]: { key: 'creation', label: 'Création', shortLabel: 'C', description: 'Nouvelle fonctionnalité', color: '#67c23a' },
    [CrudType.Modification]: { key: 'modification', label: 'Modification', shortLabel: 'M', description: 'Évolution existante', color: '#e6a23c' },
    [CrudType.Deletion]: { key: 'deletion', label: 'Suppression', shortLabel: 'S', description: 'Retrait de fonctionnalité', color: '#f56c6c' }
  }
})

/** @deprecated Utiliser useCrudTypeLabels() */
export interface CrudTypeOption {
  value: CrudType
  label: string
  shortLabel: string
  description: string
  color: string
}

/** @deprecated Utiliser useCrudTypeLabels().options */
export function getCrudTypeOptions(): CrudTypeOption[] {
  return [
    { value: CrudType.Creation, label: 'Création', shortLabel: 'C', description: 'Nouvelle fonctionnalité', color: '#67c23a' },
    { value: CrudType.Modification, label: 'Modification', shortLabel: 'M', description: 'Évolution existante', color: '#e6a23c' },
    { value: CrudType.Deletion, label: 'Suppression', shortLabel: 'S', description: 'Retrait de fonctionnalité', color: '#f56c6c' }
  ]
}

/** @deprecated Utiliser useCrudTypeLabels().getLabel() */
export function getCrudTypeLabel(crudType: CrudType): string {
  switch (crudType) {
    case CrudType.Creation: return 'Création'
    case CrudType.Modification: return 'Modification'
    case CrudType.Deletion: return 'Suppression'
    default: return 'Création'
  }
}

/** @deprecated Utiliser useCrudTypeLabels().getColor() */
export function getCrudTypeColor(crudType: CrudType): string {
  switch (crudType) {
    case CrudType.Creation: return '#67c23a'
    case CrudType.Modification: return '#e6a23c'
    case CrudType.Deletion: return '#f56c6c'
    default: return '#67c23a'
  }
}
